<template>
  <div>
    <header-slot>
      <template v-slot:content-right>
        <div class="mr-2">
          <b-button
            v-if="routeName === 'settings-payroll-holidays'"
            v-b-tooltip.hover.left="$t('ADD HOLIDAY')"
            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="outline-primary"
            class="ml-1"
            @click="openAddOrUpdateHoliday"
          >
            <div class="d-flex justify-content-between">
              <span v-t="'ADD HOLIDAY'"></span>
            </div>
          </b-button>
        </div>
      </template>
    </header-slot>

    <b-nav card-header pills class="m-0">
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        :to="{ name: item.name }"
        exact
        exact-active-class="active"
        :link-classes="['px-3', bgTabsNavs]"
        >{{ $t(item.title) | capitalize }}
      </b-nav-item>
    </b-nav>
    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <router-view ref="routerViewTab" :key="routeName" />
    </b-card>

    <AddOrUpdateHoliday
      v-if="showAddOrUpdateHoliday"
      :action="'add'"
      @hidden="showAddOrUpdateHoliday = false"
      @stored="onStoreHoliday"
    />
  </div>
</template>


<script>
/* SERVICES */
import { mapGetters } from "vuex";
import Ripple from "vue-ripple-directive";
import AddOrUpdateHoliday from "@/views/settings/views/payroll/components/holidays/ModalAddOrUpdateHoliday.vue";

export default {
  components: { AddOrUpdateHoliday },
  directives: {
    Ripple,
  },
  data() {
    return {
      sidebarEmployee: false,
      filters: false,
      showAddOrUpdateHoliday: false,
    };
  },
  created() {},
  computed: {
    tabs() {
      return this.$route.matched[1].meta.tabs;
    },
    currentTab() {
      return this.$route.meta.tab;
    },
    routeName() {
      return this.$route.name;
    },
  },
  methods: {
    openAddOrUpdateHoliday() {
      this.showAddOrUpdateHoliday = true;
    },
    onStoreHoliday() {
      this.showAddOrUpdateHoliday = false;
      this.$refs.routerViewTab.onUpdateHoliday();
    },
  },
};
</script>
    
    
    